document.addEventListener('DOMContentLoaded', () => {
  const messageBox = document.getElementById('cart-validation-message');
  const cartContainer = document.getElementById('main-cart-items');
  if (!messageBox || !cartContainer) return;

  /* =========================================================
     CART VALIDATION MESSAGES
     ========================================================= */
  const CART_VALIDATION_MESSAGES = {
    export_limit: {
      de: `
        <strong>Exportwert-Limit</strong>
        <span class="cart-validation-text">
          Bestellungen außerhalb der EU sind auf maximal 1.000 € inkl. Versand begrenzt.
          Da Versand- und Exportkosten je nach Inhalt und Gewicht variieren, kann diese Grenze
          bereits vor Erreichen von 1.000 € im Warenkorb greifen.
          Bitte reduziere den Warenkorb oder kontaktiere uns für ein manuelles Exportangebot.
        </span>
      `,
      en: `
        <strong>Export value limit</strong>
        <span class="cart-validation-text">
          Orders shipped outside the EU are limited to a maximum of €1,000 including shipping.
          Because shipping and export costs depend on weight and contents, this limit may apply
          before the cart total reaches €1,000.
          Please reduce your cart value or contact us for a manual export quote.
        </span>
      `
    },

    uk_minimum: {
      de: `
        <strong>Mindestbestellwert Großbritannien</strong>
        <span class="cart-validation-text">
          Der Mindestbestellwert für Lieferungen nach Großbritannien beträgt 170 €.
        </span>
      `,
      en: `
        <strong>UK minimum order value</strong>
        <span class="cart-validation-text">
          The minimum order value for shipments to the UK is €170.
        </span>
      `
    },

    kettle_115_restriction: {
      de: `
        <strong>115 L Kessel – Versandbeschränkung</strong>
        <span class="cart-validation-text">
          Der 115 L Kessel kann nicht in das ausgewählte Land versendet werden.
          Bitte entferne diesen Artikel oder kontaktiere uns für eine Sonderlösung.
        </span>
      `,
      en: `
        <strong>115 L kettle restriction</strong>
        <span class="cart-validation-text">
          The 115 L kettle cannot be shipped to your selected country.
          Please remove this item or contact us for a custom shipping arrangement.
        </span>
      `
    },

    no_shipping_rates: {
      de: `
        <strong>Manuelle Versandabwicklung erforderlich</strong>
        <span class="cart-validation-text">
          Lieferungen in dein Land sind derzeit nur per individuellem Versandangebot möglich.
          Bitte kontaktiere uns vor der Bestellung.
        </span>
      `,
      en: `
        <strong>Manual shipping required</strong>
        <span class="cart-validation-text">
          Shipping to your country is currently only available via manual quote.
          Please contact us before placing an order.
        </span>
      `
    }
  };

  const getMessage = (key, lang) =>
    CART_VALIDATION_MESSAGES[key]?.[lang] || '';

  /* =========================================================
    CHECKOUT BUTTON CONTROL
    ========================================================= */
  const checkoutButtons = () =>
    document.querySelectorAll(
      'button[name="checkout"], button[type="submit"][name="checkout"]'
    );

  const getDynamicButtons = () =>
    document.querySelectorAll(
      '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="dynamic-checkout-cart"]'
    );

  const disableCheckout = () => {
    document.body.classList.add('cart-validation-blocked');

    checkoutButtons().forEach(btn => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('disabled');
    });

    // JS fallback: hide dynamic buttons that may be injected later
    getDynamicButtons().forEach(el => {
      el.setAttribute('data-cart-validation-hidden', 'true');
      el.style.display = 'none';
    });
  };

  const enableCheckout = () => {
    document.body.classList.remove('cart-validation-blocked');

    checkoutButtons().forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
    });

    // Restore only what we hid ourselves
    getDynamicButtons().forEach(el => {
      if (el.getAttribute('data-cart-validation-hidden') === 'true') {
        el.style.display = '';
        el.removeAttribute('data-cart-validation-hidden');
      }
    });
  };

  /* =========================================================
    PRODUCT RESTRICTIONS
    ========================================================= */
  const RESTRICTED_115L_SKUS = new Set([
    'BKM28734',
    'BKM28726',
    'BKM28735',
    'BKM28733',
    'BAM22111',
    'BAM22083',
    'BAM22088',
    'BAM22095',
    'BAM22103'
  ]);

  /* =========================================================
     CORE VALIDATION
     ========================================================= */
  const validateCart = () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const locale = document.documentElement.lang || 'en';
        const lang = locale.startsWith('de') ? 'de' : 'en';
        const country =
          Shopify?.country || Shopify?.locale?.country || '';

        const subtotal = cart.total_price / 100;
        const items = cart.items;

        const has115LKettle = items.some(item =>
          item.sku && RESTRICTED_115L_SKUS.has(item.sku)
        );

        let message = null;

        const NO_RATE_COUNTRIES = ['US', 'AU'];

        if (NO_RATE_COUNTRIES.includes(country)) {
          message = getMessage('no_shipping_rates', lang);
        }

        if (!message && ['LI', 'CH'].includes(country) && subtotal > 940) {
          message = getMessage('export_limit', lang);
        }

        if (!message && ['IS', 'NO'].includes(country) && subtotal > 936) {
          message = getMessage('export_limit', lang);
        }

        if (!message && country === 'GB' && subtotal > 945) {
          message = getMessage('export_limit', lang);
        }

        if (!message && country === 'GB' && subtotal < 170) {
          message = getMessage('uk_minimum', lang);
        }

        if (!message && has115LKettle && !['DE', 'AT'].includes(country)) {
          message = getMessage('kettle_115_restriction', lang);
        }

        if (message) {
          messageBox.innerHTML = message;
          messageBox.hidden = false;
          disableCheckout();
        } else {
          messageBox.hidden = true;
          enableCheckout();
        }
      });
  };

  /* =========================================================
     OBSERVE CART CHANGES
     IMPORTANT:
     Dawn does not emit reliable cart update events on the cart page.
     We use a MutationObserver on #main-cart-items to revalidate whenever
     Shopify updates the cart DOM (quantity changes, removals, price updates).
     ========================================================= */
  const observer = new MutationObserver(() => {
    validateCart();
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });

  // Initial run
  validateCart();
});
